export default class {
    static projectName = "Chirayu Child Care Clinic";
    static userData = "USER_DATA";
    static themeColor = '#c00000';
    static blueColor = '#0990ec';
    static greenColor = "#00ad23";
    static baseURL = (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"))
        ? "http://localhost:8085"
        : "https://api.chirayuchildcareclinic.com";
    // static baseURL = "https://192.168.218.231:8085";
    // static baseURL = "http://18.210.234.238:8085";
    static emailRjx = /\S+@\S+\.\S+/;
}